module.exports = __webpack_public_path__ + "static/media/tick-circle.20cb5f13.svg";